import { useTranslation } from 'react-i18next'
import { RadioOptionPicker } from '../../../../components/common/Form/RadioOptionPicker/RadioOptionPicker'
import { Option } from '../../../../components/common/Form/types'
import { IntervalTimeParam } from '@/hooks/useApi/useActiveManagementApi/types'

export const TimeIntervalSelect: React.FC<{
    value: IntervalTimeParam
    onChange: (type: IntervalTimeParam) => void
}> = (props) => {
    const { t } = useTranslation('translations')
    const { value, onChange } = props

    const options: Array<Option<IntervalTimeParam>> = [
        {
            value: 'fifteenMinutes',
            label: t(
                'active_management.interval.report_settings.data_setup.timeInterval.15_minutes.label'
            ),
        },
        {
            value: 'oneHour',
            label: t(
                'active_management.interval.report_settings.data_setup.timeInterval.1_hour.label'
            ),
        },
        {
            value: 'oneDay',
            label: t(
                'active_management.interval.report_settings.data_setup.timeInterval.1_day.label'
            ),
        },
    ]

    return (
        <RadioOptionPicker
            name="time-interval"
            label={t(
                'active_management.interval.report_settings.data_setup.timeInterval.label'
            )}
            value={value}
            options={options}
            onChange={(newValue: string) => {
                onChange(newValue as IntervalTimeParam)
            }}
            renderLabel={(option) => (
                <div className="flex flex-col">
                    <div className="text-label-small text-regular">
                        {option.label}
                    </div>
                    {option.subtitle && (
                        <div className="text-body-small font-normal text-subtle">
                            {option.subtitle}
                        </div>
                    )}
                </div>
            )}
        />
    )
}
